module.exports = __webpack_public_path__ + "img/stickers_0018_stethescope.4cab3226.png";